import apiClient from "../api/client";
import {
  Currency,
  CreateCurrencyRequest,
  UpdateCurrencyRequest,
  UpdateCurrencyStatusRequest,
  PagedCurrencyResponse
} from "../types/currencytypes";

export async function getCurrencies(
  search: string,
  status: "all" | "active" | "inactive",
  limit = 10,
  offset = 0
): Promise<PagedCurrencyResponse> {
  const response = await apiClient.get("/api/currencies", {
    params: {
      search,
      status,
      limit,
      offset,
    },
  });

  return response.data;
}

export async function getActiveCurrencies(): Promise<Currency[]> {
  const response = await apiClient.get("/api/currencies/active");
  return response.data;
}

export async function getCurrencyById(guid: string): Promise<Currency> {
  const response = await apiClient.get(`/api/currencies/${guid}`);
  return response.data;
}

export async function createCurrency(
  payload: CreateCurrencyRequest
): Promise<Currency> {
  const response = await apiClient.post(
    "/api/currencies/create",
    payload
  );
  return response.data;
}

export async function updateCurrency(
  guid: string,
  payload: UpdateCurrencyRequest
): Promise<void> {
  await apiClient.put(`/api/currencies/${guid}`, payload);
}

export async function updateCurrencyStatus(
  guid: string,
  payload: UpdateCurrencyStatusRequest
): Promise<void> {
  await apiClient.put(
    `/api/currencies/${guid}/status`,
    payload
  );
}